export enum DeeplinkKeys {
  tool = 'tool',
  taskId = 'task_id',
  presetId = 'presetId',
  projectId = 'projectId',
  category = 'genaicategory',
  socialShareState = 'state',
  presetJsonUrl = 'presetJsonUrl',
  hideBackButton = 'hideBackButton',
}
